<!DOCTYPE html>
<head>
<meta name="viewport" content="width=device-width, initial-scale=1">
</head>
<ng-container *ngIf="user">
  <app-toolbar   [title]="title" [user]="user" [back]="true" [destination]="destination"></app-toolbar>
</ng-container>

<div class="row">
<div class="column">
<mat-card><mat-card-title>Domande "Questionario di gradimento" - Compilati: {{Tot_questionnaires}}</mat-card-title>
<mat-card-content>
  <table mat-table [dataSource]="dataSource">
  
    <ng-container matColumnDef="position">
      <th mat-header-cell *matHeaderCellDef> No. </th>
      <td mat-cell *matCellDef="let questionnaire"> {{questionnaire.position}} </td>
    </ng-container>

    <ng-container matColumnDef="question">
      <th mat-header-cell *matHeaderCellDef> Domanda </th>
      <td mat-cell *matCellDef="let questionnaire"> {{questionnaire.question}} </td>
    </ng-container>

    <ng-container matColumnDef="avg_score">
      <th mat-header-cell *matHeaderCellDef> Score medio </th>
      <td mat-cell *matCellDef="let questionnaire"> {{nums[questionnaire.position-1]}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</mat-card-content></mat-card>
</div>

<div class="column" style="float:left;">
    <h2>Punteggio medio questionario gradimento</h2>
    <div style="display: inline-block" style = "padding-left: 3vw; padding-top: 0vw; position: center">
      <div class = "chart-container" [ngStyle]="{'cursor': isHovered ? 'pointer' : ''}">
        <canvas id = "myChartQuestionnaireGradimento"></canvas>
      </div>
    </div>
  </div>
</div>


<div class="row">
<mat-card>
  <mat-card-content>
      <table id="table_suggerimenti">
        <tr><th><h1>Suggerimenti inseriti: {{Tot_suggerimenti}}</h1></th></tr>
        <tr *ngFor="let item of suggerimenti; index as i">
            <td>{{item}}</td>
        </tr>
    </table>
  </mat-card-content>
  </mat-card>
</div>